import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import FormGroup from '../FormGroup';

const propTypes = {
  className: PropTypes.string,
  length: PropTypes.number,
  autofocus: PropTypes.bool,
  onChange: PropTypes.func,
  onComplete: PropTypes.func,
};

const PinField = ({
  className,
  length = 4,
  autofocus = true,
  onChange,
  onComplete,
  ...props
}) => {
  const classes = classNames({
    'pin-field mb-0': true,
    [className]: !!className,
  });
  const [pin, setPin] = useState('');
  const max = '9'.repeat(length);
  const ref = useRef(null);

  useEffect(() => {
    if (autofocus && ref.current) {
      ref.current.focus();
    }
  }, [ref.current, autofocus]);

  useEffect(() => {
    onChange?.(pin);

    if (pin.length === length) {
      onComplete?.(pin);
    }
  }, [pin]);

  return (
    <FormGroup
      id="pin-field"
      label="Enter the PIN"
      labelSrOnly
      {...props}
      onChange={event => {
        const { value } = event.target;

        if (value.length > length) {
          return;
        }

        setPin(value);
      }}
      value={pin}
      type="number"
      pattern={/^[0-9]$/}
      maxLength={length}
      min={-max}
      max={max}
      inputClassName="pin-field-input"
      className={classes}
      inputRef={ref}
    />
  );
};

PinField.propTypes = propTypes;

export default PinField;
